import debounce from 'lodash.debounce';
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

type BlockState = 'blocked' | 'unblocked' | 'proceeding';

export interface IAppSlice {
  action?: 'add' | 'edit' | 'view' | 'import';
  backendVersion: string | undefined;
  blockNavigation: boolean;
  blockState: BlockState;
  blockTarget: string;
  documentation: string[];
  documentationData: Record<string, any>;
  documentationRunning: boolean;
  icon?: string;
  title: string;
  version: string;
}

const changeTitle = debounce((title?: string) => {
  if (title === undefined) {
    document.title = 'Pointage — CSN';
    return;
  }

  document.title = [...title.split('|'), 'Pointage', 'CSN'].filter((s) => !!s).join(' — ');
}, 300);

const initialState: IAppSlice = {
  action: undefined,
  backendVersion: undefined,
  blockNavigation: false,
  blockState: 'unblocked',
  blockTarget: '',
  documentation: [],
  documentationData: {},
  documentationRunning: false,
  icon: undefined,
  title: '',
  version: '1.0.0',
};

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    action: (state, { payload }: PayloadAction<IAppSlice['action']>) => {
      state.action = payload;
    },
    addDocumentationData: (state, { payload: { key, value } }: PayloadAction<{ key: string; value: any }>) => {
      state.documentationData[key] = value;
    },
    blockNavigation: (state, { payload }: PayloadAction<IAppSlice['blockNavigation']>) => {
      state.blockNavigation = payload;
    },
    blockState: (state, { payload }: PayloadAction<IAppSlice['blockState']>) => {
      state.blockState = payload;
    },
    blockTarget: (state, { payload }: PayloadAction<IAppSlice['blockTarget']>) => {
      state.blockTarget = payload;
    },
    documentation: (state, { payload }: PayloadAction<IAppSlice['documentation']>) => {
      state.documentation = payload;
    },
    documentationRunning: (state, { payload }: PayloadAction<IAppSlice['documentationRunning']>) => {
      state.documentationRunning = payload;
    },
    icon: (state, { payload }: PayloadAction<IAppSlice['icon']>) => {
      state.icon = payload;
    },
    fetchBackendVersion: (_state) => {},
    goto: (_state) => {},
    resetDocumentationData: (state) => {
      state.documentationData = {};
    },
    setBackendVersion: (state, { payload }) => {
      state.backendVersion = payload;
    },
    title: (state, { payload }: PayloadAction<IAppSlice['title']>) => {
      changeTitle(payload);
      state.title = payload;
    },
  },
});

export const { actions, reducer } = appSlice;
